import { mode_edit, mode_view } from '../../../../../../views/my-store/google-profile';

export default {
  title: 'Profilo Google',
  sections: {
    current_profile: {
      [mode_view]: 'Profilo connesso',
      [mode_edit]: 'Cambia profilo connesso',
    },
  },
  form: {
    google_places_id: {
      label: 'Nome su Google Maps',
    },
    address: {
      label: 'Indirizzo',
    },
    rating: {
      label: 'Valutazione',
    },
    opening_hours: {
      label: 'Orari di apertura',
    },
    phone_number: {
      label: 'Numero di telefono',
    },
    pictures: {
      label: 'Immagini',
    },
  },
  labels: {
    no_place_connected: 'Questo ristorante non ha un profilo Google connesso',
    fields_to_sync: 'Informazioni da sincronizzare da {{name}}',
  },
  buttons: {
    save: 'Salva',
    change: 'Modifica',
    cancel: 'Annulla',
  },
  toasts: {
    failed_to_save_changes: 'Salvataggio delle modifiche non riuscito',
    changes_got_saved: 'Modifiche salvate',
  },
};
